module.exports = __webpack_public_path__ + "static/media/x-x axis.7112ec3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/x-x axis.png
// module id = 193
// module chunks = 0